import "./footer.css";
import { Link } from "react-router";
import { HashLink } from "react-router-hash-link";

export default function Footer() {
  const menu = [
    {
      name: "Главная",
      link: "#heroPage",
      id: 1,
    },
    {
      name: "О нас",
      link: "#about",
      id: 2,
    },
    {
      name: "Услуги",
      link: "#legalFees",
      id: 3,
    },
    {
      name: "Кейсы",
      link: "#cases",
      id: 4,
    },
    {
      name: "Контакты",
      link: "#contacts",
      id: 5,
    },
  ];
  return (
    <footer>
      <h3>
        ЛИДЕР <span>ПРАВА</span>
      </h3>
      <div className="footerContainer">
        <hr />
        <nav>
          {menu.map((item, index) => (
            <div key={index}>
              <HashLink to={`/` + item.link} smooth>
                {item.name}
              </HashLink>
            </div>
          ))}
        </nav>
        <hr />
        <div className="col footerDiv">
          <span>Связаться с нами: </span>
          <div className="row">
            <img
              src={process.env.PUBLIC_URL + "/images/addressW.svg"}
              alt="адрес"
            />
            <p style={{ textIndent: "0" }}>
              428003, Чувашская Республика, <br />
              г. Чебоксары, ул. Афанасьева, д. 2, оф. 56.
            </p>
          </div>
          <div className="row">
            <img
              src={process.env.PUBLIC_URL + "/images/phoneW.svg"}
              alt="телефон"
            />
            <a
              href="tel:+79603128406"
              style={{ textDecoration: "none" }}
              title="Телефон для связи"
            >
              +7(960)312-84-06
            </a>
          </div>
          <div className="row">
            <img
              src={process.env.PUBLIC_URL + "/images/mailW.svg"}
              alt="почта"
            />
            <a href="mailto:mailto:liderprava@ya.ru" title="Почта для связи">
              liderprava21@ya.ru
            </a>
          </div>
          <div className="row" style={{ marginTop: "1rem" }}>
            <a href="https://t.me/liderpravapfo" title="Телеграм">
              <img
                src={process.env.PUBLIC_URL + "/images/tgW.svg"}
                alt="телеграм"
              />
            </a>
            <a href="https://vk.com/liderpravapfo" title="ВКонтакте">
              <img
                src={process.env.PUBLIC_URL + "/images/vkW.svg"}
                alt="ВКонтакте"
              />
            </a>
            <a
              href="https://max.ru/join/KlnqqnrRDC6nN8p5G22IyKGhOCkcbRs-D830bo4qWQM"
              title="Мессенджер Макс"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/max.svg"}
                alt="Макс"
              />
            </a>
            {/*Раскомментить в лучшие времена */}
            {/*<a
              href="https://api.whatsapp.com/send/?phone=79603128406&amp;text=Здравствуйте%21%0A%0AПишу+из+приложения+2ГИС.%0A%0A&amp;type=phone_number&amp;app_absent=0"
              title="WhatsApp"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/whatsappW.svg"}
                alt="WhatsApp"
              />
            </a>*/}
          </div>
        </div>
        <hr />
        <div className="col feedback-footer">
          <span>Читайте отзывы о нас: </span>
          <div className="row" style={{ marginTop: "1rem" }}>
            <a
              href="https://yandex.ru/maps/org/lider_prava/34845163518/reviews/?ll=50.123226%2C55.641204&z=7"
              title="Отзывы на Яндексе"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/yandexW.svg"}
                alt="яндекс отзывы"
              />
            </a>
            <a
              href="https://2gis.ru/cheboksary/firm/70000001053905641/tab/reviews"
              title="Отзывы на 2гис"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/2gisW.svg"}
                alt="2gis отзывы"
              />
            </a>
          </div>
        </div>
        <hr />
        <div className="col footerDiv">
          <Link to="/consent">Соглашение об обработке данных</Link>
          <Link to="/privacy_policy">Политика конфиденциальности</Link>
        </div>
        <hr />
      </div>
      <p className="url">LIDER-PRAVA.RU</p>
    </footer>
  );
}
